import { apiClient } from "../../../config/axios.config";
import type { ListResponse } from "../../../types/api.types";
import type { ZoneType } from "../dtos/response/category.response";

const model = "/v1/category";

export const getZoneGroup = async (): Promise<ListResponse<ZoneType>> => {
  const { data } = await apiClient.get(`${model}/zoneGroup`);
  return data;
};
